import Alpine from "alpinejs";

const data = (params = {}) => ({
  /**
   *  Data
   */
  checkedList: [],
  termSelectedOption: '12',
  exchangeSelectedOption: 0,
  fundTimeList: [],
  rankingSoukanSelectedOption: 0,
  sortSelectedOption: '',
  functionSortOption: 'profit,12',
  storageKey: '',
  /**
   *  Targets
   */

  targets: {
    termSelectedOption: {
      ['x-model']: 'termSelectedOption',
      ['x-on:change']: 'termChangeRoute'
    },
    exchangeSelectedOption: {
      ['x-model']: 'exchangeSelectedOption',
      ['x-on:change']: 'exchangeChangeRoute'
    },
    fundTimeList: {
      ['x-model']: 'fundTimeList',
      ['x-on:change']: 'fundTimeChangeRoute'
    },
    rankingSoukanSelectedOption: {
      ['x-model']: 'rankingSoukanSelectedOption',
      ['x-on:change']: 'rankingSoukanChangeRoute'
    },
    sortSelectedOption: {
      ['x-model']: 'sortSelectedOption',
      ['x-on:change']: 'sortChangeRoute'
    },
    functionSortOption: {
      ['x-model']: 'functionSortOption',
      ['x-on:change']: 'functionSortChangeRoute'
    }
  },
  /**
   *  Main & Event Callback
   */

  init() {
    this.storageKey = `checkedList_${window.location.pathname}`;

    const storedCheckedList = sessionStorage.getItem(this.storageKey);
    if (storedCheckedList && storedCheckedList.length > 0) {
      this.checkedList = JSON.parse(storedCheckedList);
      this.showCompareSection = true
    } else {
      this.showCompareSection = false
    }
    this.checkedListChange()
    this.initRoute()
    this.updateCheckboxes()
  },
  initRoute() {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search)

    this.rankingSoukanSelectedOption = search.has('soukan') ? search.get('soukan') : 0
    this.exchangeSelectedOption = search.has('exchange') ? search.get('exchange') : 0
    this.fundTimeList = search.has('fund_times') ? search.get('fund_times').split(',') : []
    this.termSelectedOption = search.has('term') ? search.get('term') : '12'
    this.sortSelectedOption = search.has('order_by') ? search.get('order_by') : 'display_order'
    this.functionSortOption = search.has('search_result_sort') ? search.get('search_result_sort') : 'profit,12'
    this.yearNoticeOption = search.has('year') ? search.get('year') : ''
  },
  checkedListChange() {
    this.$watch('checkedList', value => {
      if(value.length > 0) {
        this.showCompareSection = true
        sessionStorage.setItem(this.storageKey, JSON.stringify(value));
      } else {
        this.showCompareSection = false
        sessionStorage.removeItem(this.storageKey);
      }
    })
  },
  termChangeRoute() {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search)
  
    if(this.termSelectedOption != '12') {
      search.set('term', this.termSelectedOption)
    } else {
      search.delete('term')
    }
    url.search = search.toString()
    window.location.href= url.toString()
  },
  exchangeChangeRoute() {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search)
    if(this.exchangeSelectedOption != 0) {
      search.set('exchange', this.exchangeSelectedOption)
    } else {
      search.delete('exchange')
    }
    url.search = search.toString().replace(/%2C/g, ',')
    window.location.href= url.toString()
  },
  fundTimeChangeRoute() {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search)
    
    if(this.fundTimeList.length > 0) {
      search.set('fund_times', this.fundTimeList.toString())
    } else {
      search.delete('fund_times')
    }
    url.search = search.toString().replace(/%2C/g, ',')
    window.location.href= url.toString()
  },
  rankingSoukanChangeRoute() {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search) 
    if(this.rankingSoukanSelectedOption != 0) {
      search.set('soukan', this.rankingSoukanSelectedOption)
    } else {
      search.delete('soukan')
    }
    url.search = search.toString()
    window.location.href= url.toString()
  },
  checkboxChange(id) {
    if (this.checkedList.includes(id)) {
      this.checkedList = this.checkedList.filter(v => v !== id)
    } else {
      if (this.checkedList.length < 10) {
        this.checkedList.push(id)
      } else {
        alert('※比較対象は最大五個まで')
        this.$event.target.checked = false
      }
    }
  },
  sortChangeRoute() {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search)
  
    if(this.sortSelectedOption != 'display_order') {
      search.set('order_by', this.sortSelectedOption)
    } else {
      search.delete('order_by')
    }
    url.search = search.toString()
    window.location.href= url.toString()
  },
  functionSortChangeRoute() {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search)
  
    if(this.functionSortOption != 'profit,12') {
      search.set('search_result_sort', this.functionSortOption)
    } else {
      search.delete('search_result_sort')
    }
    url.search = search.toString().replace(/%2C/g, ',')
    window.location.href= url.toString()
  },
  yearNoticeChangeRoute(value) {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(url.search)
  
    if(value != '') {
      search.set('year', value)
    } else {
      search.delete('year')
    }
    url.search = search.toString()
    window.location.href= url.toString()
  },
  updateCheckboxes() {
    const storedCheckedList = sessionStorage.getItem('checkedList');
    if (storedCheckedList) {
      this.checkedList = JSON.parse(storedCheckedList);
    }

    this.$nextTick(() => {
      const checkboxes = this.$el.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.checked = this.checkedList.includes(checkbox.value);
      });
    });
  },
  ...params
})

Alpine.data('routeFilter', data)
export default data
